import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
// import { FuseConfigService } from '@fuse/services/config.service';
// import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { OAuthService } from 'angular-oauth2-oidc';
import { Router } from '@angular/router';

@Component({
  selector: 'pag-mantenimiento',
  templateUrl: './pag-mantenimiento.component.html',
  styleUrls: ['./pag-mantenimiento.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})
export class PagMantenimientoComponent implements OnInit {

  constructor(
    // private _fuseConfigService: FuseConfigService,
    private _oauthService: OAuthService,
    private _router: Router,
  ) {
    // this._fuseConfigService.config = {
    //   layout: {
    //     navbar: {
    //       hidden: true
    //     },
    //     toolbar: {
    //       hidden: true
    //     },
    //     footer: {
    //       hidden: true
    //     },
    //     sidepanel: {
    //       hidden: true
    //     }
    //   }
    // };
  }

  ngOnInit() {
  }

}
